import { PropsWithChildren, useEffect, useState } from "react";
import { ChainContext } from "../context/ChainContext";
import { JsonRpc, NamingNodeProvider } from "upcx-js";
import * as Api from "../openApi";
import { Quote } from "../openApi/api";
import { Shard } from "upcx-js/dist/upcxjs-api-interfaces";
import { SESSION_STORAGE_KEY } from "../common/const";
import { OpenAPI, QuotesService } from "../backend";

export const ChainProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [shards, setShards] = useState<Shard[]>([]);
  const [selectedShard, setSelectedShard] = useState<Shard>();
  const [quoteUSD, setQuoteUSD] = useState<Quote>();
  const [quoteJPY, setQuoteJPY] = useState<Quote>();
  const [jsonRpc, setJsonRpc] = useState<JsonRpc>();

  const [initialized, setInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      return;
    }

    init();
  }, [initialized]);

  useEffect(() => {
    if (!selectedShard) {
      return;
    }

    setJsonRpc(new JsonRpc(selectedShard.rpcList[0].sslUrl));
  }, [selectedShard]);

  const init = async () => {
    const namingProvider = new NamingNodeProvider(
      process.env.REACT_APP_NAMING_RPC!
    );

    const shards = await namingProvider.getShardList();
    setShards(shards);

    try {
      const selectedShard = JSON.parse(
        sessionStorage.getItem(SESSION_STORAGE_KEY.SELECTED_SHARD)!
      );

      if (!selectedShard) {
        throw new Error();
      } else {
        handleSelectedShard(selectedShard);
      }
    } catch {
      handleSelectedShard(shards[0]);
    }

    getMarketCapData();
  };

  const getMarketCapData = async () => {
    try {
      const result = await QuotesService.getTokenQuote("UPC");
      setQuoteUSD(result.find((x) => x.base === "USD"));
      setQuoteJPY(result.find((x) => x.base === "JPY"));
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeShard = (shardID: string) => {
    for (let i = 0; i < shards.length; i++) {
      if (shards[i].shardId === shardID) {
        handleSelectedShard(shards[i]);
        return;
      }
    }
  };

  const handleSelectedShard = (shard: Shard) => {
    OpenAPI.BASE = shard.apiUrl;
    setSelectedShard(shard);
    sessionStorage.setItem(
      SESSION_STORAGE_KEY.SELECTED_SHARD,
      JSON.stringify(shard)
    );
  };

  return (
    <ChainContext.Provider
      value={{
        jsonRpc,
        quoteUSD,
        quoteJPY,
        shards,
        selectedShard,
        handleChangeShard,
      }}
    >
      {children}
    </ChainContext.Provider>
  );
};
